import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import PaperDraggable from "../../../../../../../../components/PaperDraggable"
import { Moment } from "moment"
import BasicDatePicker from "../../../../../../../../components/BasicDatePicker"
import { useState } from "react"

export default function DialogSelecionarData({
    open,
    handleClose,
    defValue,
    onChange,
    blockPastDates = false
}: DialogSelecionarDataProps) {

    const [value, setValue] = useState(defValue)

    const handleSubmit = () => {
        onChange(value)
        handleClose()
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            scroll="body"
            maxWidth="xs"
            fullWidth
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                Selecionar data do pagamento
            </DialogTitle>

            <DialogContent>
                <Box py={1}>
                    <BasicDatePicker
                        {...{ value, blockPastDates }}
                        label="Data pagamento"
                        onChange={(data) => setValue(data as Moment)}
                        formatString='DD/MM/YYYY'
                    />
                </Box>
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleSubmit}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogSelecionarDataProps {
    open: boolean,
    handleClose: () => void,
    defValue: Moment,
    onChange: (agr: Moment) => void,
    blockPastDates?: boolean
}

//